<div class="policy-studio setting-page">
    <legend>Policy Studio</legend>
    <div class="action-buttons">
        <arm-action-bar (addClick)="addCallItem()" [disableAdd]="isUnauthorized || isPolicyStudioDisabled"
                        (refreshClick)="refresh()" [disableRefresh]="isPolicyStudioDisabled"
                        (deleteClick)="deleteCallItem($event)" [disableDelete]="isUnauthorized || !selection || isPolicyStudioDisabled"
                        (editClick)="editCallItem($event)" [disableEdit]="!selection || isPolicyStudioDisabled">
        </arm-action-bar>
        <button [matMenuTriggerFor]="menu" class="settings-more-actions" color="primary" mat-raised-button>
            <span>Actions</span>
            <mat-icon>arrow_drop_down</mat-icon>
        </button>

        <mat-menu #menu="matMenu">
            <button (click)="moveCallItem($event)" mat-menu-item [disabled]="isUnauthorized">
                <span>Move</span>
            </button>
        </mat-menu>
    </div>

    <div class="policy-studio-container">
        <div class="policy-studio-container">
            <label class="policy-studio-title">Routing</label>
            <mat-accordion [multi]="true" class="policy-studio-list">
                <virtual-scroller cdkDropList
                                  (cdkDropListDropped)="drop($event, scroll.viewPortInfo, 'policy-studio')"
                                  #scroll [items]="policyStudioData" [childHeight]="40" [checkResizeInterval]="100"
                                  [enableUnequalChildrenSizes]="true" class="policy-studio-virtual-scroll">
                    <mat-expansion-panel (cdkDragStarted)="onDrag()" class="expansion-panel"
                                         *ngFor="let item of scroll.viewPortItems; let i = index" [expanded]="item.open"
                                         (click)="selectHandler(item)" (opened)="onOpened(item);" (closed)="onClosed(item);"
                                         (afterCollapse)="scroll.refresh()" cdkDrag hideToggle>
                        <mat-expansion-panel-header expandedHeight="40px" collapsedHeight="40px" [ngClass]="{'selected': isSelected(item)}">
                            <mat-panel-title>
                                <div class="title">
                                    <span cdkDragHandle class="material-icons move-item">drag_indicator</span>
                                    <span title="{{item.name}}">{{item.name}}</span>
                                </div>
                            </mat-panel-title>
                            <mat-panel-description>
                  <!--              <i *ngIf="!isUnauthorized" class="fa fa-trash-o action-button" (click)="selectHandler(item); deleteCallItem($event, i, item)"></i>
                                <i class="fa fa-pencil action-button" title="Edit"
                                   (click)="selectHandler(item); editCallItem($event)"></i>
                                <i *ngIf="!isUnauthorized" class="fa fa-arrows action-button" title="Move"
                                   (click)="selectHandler(item); moveCallItem($event, item)"></i>


                                <i *ngIf="!isUnauthorized && (item.adminState === 'LOCKED')" class="fa fa-lock action-button locked"
                                   title="Switch admin state" (click)="selectHandler(item); toggleCallItemState(item, $event)"></i>

                                <i *ngIf="!isUnauthorized && (item.adminState === 'UNLOCKED')" class="fa fa-unlock action-button unlocked"
                                   title="Switch admin state" (click)="selectHandler(item); toggleCallItemState(item, $event)"></i>-->

                                <i (click)="selectHandler(item); toggleCallItemState(item, $event)" class="fa fa-unlock unlock"
                                   *ngIf="!isUnauthorized && (item.adminState === 'UNLOCKED')"></i>
                                <i (click)="selectHandler(item); toggleCallItemState(item, $event)" class="fa fa-lock lock"
                                   *ngIf="!isUnauthorized && (item.adminState === 'LOCKED')"></i>
                                <span cdkDragHandle *ngIf="!isUnauthorized" (click)="$event.stopPropagation();"
                                      class="material-icons rule-options more-options" [matMenuTriggerFor]="groupMenu">more_vert</span>
                                <mat-menu #groupMenu="matMenu">
                                    <button mat-menu-item (click)="this.deleteCallItem($event, item)">
                                        <mat-icon>delete</mat-icon>
                                        <span>Delete</span>
                                    </button>
                                    <button mat-menu-item (click)="this.editCallItem($event, item)">
                                        <mat-icon>create</mat-icon>
                                        <span>Edit</span>
                                    </button>
                                    <button mat-menu-item (click)="this.moveCallItem($event, item)">
                                        <mat-icon>open_with</mat-icon>
                                        <span>Move</span>
                                    </button>
                                </mat-menu>
                            </mat-panel-description>
                        </mat-expansion-panel-header>
                        <ng-template matExpansionPanelContent>
                            <div class="content-item-container">
                                <policy-studio-match-box [item]="item" class="call-item-match-box"></policy-studio-match-box>
                                <policy-studio-action-box [item]="item" class="call-item-action-box"></policy-studio-action-box>
                            </div>
                        </ng-template>
                        <div *cdkDragPreview></div>
                    </mat-expansion-panel>
                </virtual-scroller>
            </mat-accordion>
            <label  class="policy-studio-title">Credentials</label>
            <mat-accordion [multi]="true" class="policy-studio-list">
                <virtual-scroller cdkDropList (cdkDropListDropped)="drop($event, credentialsScroll.viewPortInfo, 'credentials')" #credentialsScroll
                                  [items]="credentialsData" [childHeight]="40" [checkResizeInterval]="100"
                                  [enableUnequalChildrenSizes]="true" class="credentials-virtual-scroll">
                    <mat-expansion-panel (cdkDragStarted)="onDrag()" class="expansion-panel"
                                         *ngFor="let item of credentialsScroll.viewPortItems; let i = index"
                                         [expanded]="item.open" (click)="selectHandler(item)"
                                         (opened)="onOpened(item);" (closed)="onClosed(item);"
                                         (afterCollapse)="credentialsScroll.refresh()" cdkDrag hideToggle>
                        <mat-expansion-panel-header expandedHeight="40px" collapsedHeight="40px" [ngClass]="{'selected': isSelected(item)}">
                            <mat-panel-title>
                                <div class="title">
                                    <span cdkDragHandle class="material-icons move-item">drag_indicator</span>
                                    <span title="{{item.name}}">{{item.name}}</span>
                                </div>
                            </mat-panel-title>
                            <mat-panel-description>
                              <!--  <i *ngIf="!isUnauthorized" class="fa fa-trash-o action-button" (click)="selectHandler(item); deleteCallItem($event, i, item)"></i>
                                <i class="fa fa-pencil action-button" title="Edit"
                                   (click)="selectHandler(item); editCallItem($event)"></i>
                                <i *ngIf="!isUnauthorized" class="fa fa-arrows action-button" title="Move"
                                   (click)="selectHandler(item); moveCallItem($event, item)"></i>
                                <i *ngIf="!isUnauthorized && (item.adminState === 'LOCKED')" class="fa fa-lock action-button locked"
                                   title="Switch admin state" (click)="selectHandler(item); toggleCallItemState(item, $event)"></i>
                                <i *ngIf="!isUnauthorized && (item.adminState === 'UNLOCKED')" class="fa fa-unlock action-button unlocked"
                                   title="Switch admin state" (click)="selectHandler(item); toggleCallItemState(item, $event)"></i>-->
                         <!--       <button mat-flat-button color="primary" class="toolbar-button locked"
                                        *ngIf="!isUnauthorized && (item.adminState === 'LOCKED')"
                                        (click)="selectHandler(item); toggleCallItemState(item, $event)">UNLOCK</button>
                                <button mat-flat-button color="primary" class="toolbar-button unlocked"
                                        *ngIf="!isUnauthorized && (item.adminState === 'UNLOCKED')"
                                        (click)="selectHandler(item); toggleCallItemState(item, $event)">LOCK</button>-->


                                <i (click)="selectHandler(item); toggleCallItemState(item, $event)" class="fa fa-unlock unlock"
                                   *ngIf="!isUnauthorized && (item.adminState === 'UNLOCKED')"></i>
                                <i (click)="selectHandler(item); toggleCallItemState(item, $event)" class="fa fa-lock lock"
                                   *ngIf="!isUnauthorized && (item.adminState === 'LOCKED')"></i>
                                <span cdkDragHandle class="more-options" [hidden]="isUnauthorized" (click)="$event.stopPropagation();"
                                      class="material-icons rule-options" [matMenuTriggerFor]="groupMenu">more_vert</span>
                                <mat-menu #groupMenu="matMenu">
                                    <button mat-menu-item (click)="this.deleteCallItem($event, item)">
                                        <mat-icon>delete</mat-icon>
                                        <span>Delete</span>
                                    </button>
                                    <button mat-menu-item (click)="this.editCallItem($event, item)">
                                        <mat-icon>create</mat-icon>
                                        <span>Edit</span>
                                    </button>
                                    <button mat-menu-item (click)="this.moveCallItem($event, item)">
                                        <mat-icon>open_with</mat-icon>
                                        <span>Move</span>
                                    </button>
                                </mat-menu>
                            </mat-panel-description>
                        </mat-expansion-panel-header>
                        <ng-template matExpansionPanelContent>
                            <div class="content-item-container">
                                <policy-studio-match-box [item]="item" class="call-item-match-box"></policy-studio-match-box>
                                <policy-studio-action-box [item]="item" class="call-item-action-box"></policy-studio-action-box>
                            </div>
                        </ng-template>
                        <div *cdkDragPreview></div>
                    </mat-expansion-panel>
                </virtual-scroller>
            </mat-accordion>
        </div>
    </div>
</div>
